import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FiMenu, FiX } from 'react-icons/fi';
import './Header.css'; // Import the CSS file
import logo from '../assets/logo.png';

const Header = ({ onEnrollClick }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navItems = [
    { name: 'Home', href: '#home' },
    { name: 'Features', href: '#features' },
    { name: 'Streams', href: '#streams' },
    { name: 'Benefits', href: '#benefits' },
    { name: 'Timeline', href: '#timeline' },
  ];

  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
      className="header"
    >
      <div className="container">
        {/* Logo */}
        <div className="logo-container">
          <div className="logo">
            <a
      href="https://www.dylora.in"
      target="_blank"
      rel="noopener noreferrer"
      className="logo-link"
    >
      <img
        src={logo}
        alt="Dylora Logo"
        className="logo-image"
      />
    </a>
            {/* <span className="logo-accent">PRO</span> */}
          </div>
        </div>

        {/* Desktop Navigation */}
        <nav className="nav">
          {navItems.map((item) => (
            <a
              key={item.name}
              href={item.href}
              className="nav-link"
            >
              {item.name}
            </a>
          ))}
        </nav>

        {/* Enroll Button - Desktop */}
        <button
          onClick={onEnrollClick}
          className="enroll-button black-btn"
        >
          Enroll Now
        </button>

        {/* Mobile Menu Toggle */}
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="menu-button"
          aria-label="Toggle menu"
        >
          {isMenuOpen ? <FiX size={28} /> : <FiMenu size={28} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.3 }}
          className="mobile-nav"
        >
          {navItems.map((item) => (
            <a
              key={item.name}
              href={item.href}
              className="mobile-nav-link"
              onClick={() => setIsMenuOpen(false)}
            >
              {item.name}
            </a>
          ))}
          <button
            onClick={() => {
              onEnrollClick();
              setIsMenuOpen(false);
            }}
            className="mobile-enroll-button black-btn"
          >
            Enroll Now
          </button>
        </motion.div>
      )}
    </motion.header>
  );
};

export default Header;